var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('p',[_vm._v(" Eu estou ciente da autenticidade das informações contidas neste documento! ")]),_c('p',[_vm._v(_vm._s('_'.repeat(20)))]),_c('p',[_vm._v("Assinatura do Gate")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }